// ===== Interfaces =====

import {
    IAnnotationItem,
}                           from '../interfaces';

const getParentAnnotationId = (
    annotation: IAnnotationItem,
): string | undefined => (
    annotation.parentAnnotationId
    || annotation.comment?.parentId
);

export default getParentAnnotationId;
